<template>
    <div class="view pa24">
        <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
            :close-on-click-modal="false" :before-close="closeDialog">
            <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="100px" class="ruleForm">
                <el-form-item label="设备回收" prop="recycle">
                   <el-input v-model="ruleForm.recycle" placeholder="请输入设备号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getDeviceList, recycle, getDearler ,getNoPage} from '@/api/gps.js'
    export default {
        data() {
            return {
                dialogVisible: false,
                title: '设备回收',
                ruleForm: {
                    recycle: ''
                },
                rules: {
                    recycle: [
                        { required: true, message: '请输入设备号', trigger: 'blur' }
                    ]
                },
                deviceList: [],
                dealerList: [],
                dealerId: null,
            };
        },
        methods: {
            openDialog(type, data) {
                this.ruleForm = {};
                this.dialogVisible = true

            },
            closeDialog() {
                this.dialogVisible = false;
            },
            confirmAddDealer() {
                this.$refs.dealerRuleForm.validate((valid) => {
                    if (valid) {
                        // 构建params
                        let params = {
                            Iccid: this.ruleForm.recycle
                        }
                        recycle(params).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '设置成功'
                                })
                                this.closeDialog()
                                this.getDeviceList()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

        }
    };

</script>